// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DiagramBuilderDefaultPromptsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DiagramBuilderDefaultPromptsQuery = { __typename?: 'Query', defaultDiagramPrompts: Array<{ __typename?: 'DefaultDiagramPrompt', diagramArtifactPromptType: Types.DiagramArtifactPromptDiagramArtifactPromptType }> };

export const Operations = {
  Query: {
    DiagramBuilderDefaultPrompts: 'DiagramBuilderDefaultPrompts' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const DiagramBuilderDefaultPromptsDocument = gql`
    query DiagramBuilderDefaultPrompts {
  defaultDiagramPrompts {
    diagramArtifactPromptType
  }
}
    `;

/**
 * __useDiagramBuilderDefaultPromptsQuery__
 *
 * To run a query within a React component, call `useDiagramBuilderDefaultPromptsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiagramBuilderDefaultPromptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiagramBuilderDefaultPromptsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDiagramBuilderDefaultPromptsQuery(baseOptions?: Apollo.QueryHookOptions<DiagramBuilderDefaultPromptsQuery, DiagramBuilderDefaultPromptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiagramBuilderDefaultPromptsQuery, DiagramBuilderDefaultPromptsQueryVariables>(DiagramBuilderDefaultPromptsDocument, withFetchPolicyContext(options));
      }
export function useDiagramBuilderDefaultPromptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiagramBuilderDefaultPromptsQuery, DiagramBuilderDefaultPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiagramBuilderDefaultPromptsQuery, DiagramBuilderDefaultPromptsQueryVariables>(DiagramBuilderDefaultPromptsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useDiagramBuilderDefaultPromptsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DiagramBuilderDefaultPromptsQuery, DiagramBuilderDefaultPromptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiagramBuilderDefaultPromptsQuery, DiagramBuilderDefaultPromptsQueryVariables>(DiagramBuilderDefaultPromptsDocument, withFetchPolicyContext(options));
        }
export type DiagramBuilderDefaultPromptsQueryHookResult = ReturnType<typeof useDiagramBuilderDefaultPromptsQuery>;
export type DiagramBuilderDefaultPromptsLazyQueryHookResult = ReturnType<typeof useDiagramBuilderDefaultPromptsLazyQuery>;
export type DiagramBuilderDefaultPromptsSuspenseQueryHookResult = ReturnType<typeof useDiagramBuilderDefaultPromptsSuspenseQuery>;
export type DiagramBuilderDefaultPromptsQueryResult = Apollo.QueryResult<DiagramBuilderDefaultPromptsQuery, DiagramBuilderDefaultPromptsQueryVariables>;